module.exports = __webpack_public_path__ + "assets/img/image_icon.96a913c8.svg";